module.exports = __webpack_public_path__ + "static/img/9Marketing.6d2b5637.gif";